<template>
  <div class="page pageBreakBefore">
    <div class="subreport-header">
      Participant Staff Potential
    </div>
    <div class="row">
      <div class="col-2 text-left text-danger">
        Participant
      </div>
      <div class="col-2 text-center text-danger">
        Patrol
      </div>
      <div class="col-1 text-center text-danger">
        For Sure
      </div>
      <div class="col-1 text-center text-danger">
        Likely
      </div>
      <div class="col-1 text-center text-danger">
        Maybe
      </div>
      <div class="col-1 text-center text-danger">
        Not Likely
      </div>
      <div class="col-1 text-center text-danger">
        NYLT
      </div>
      <div class="col-3 text-left text-danger">
        Comments
      </div>
    </div>
    <div
      class="row pt-2 pb-2 border-bottom"
      v-for="p in participants"
      :key="p.ScouterKey"
    >
      <div class="col-2 text-left">
        {{ p.FullName }}
      </div>
      <div class="col-2 text-center">
        {{ p.Critter }}
      </div>
      <div class="col-1 text-center">
        {{ p.StaffRecommendation === "Forsure" ? "X" : "" }}
      </div>
      <div class="col-1 text-center">
        {{ p.StaffRecommendation === "Likely" ? "X" : "" }}
      </div>
      <div class="col-1 text-center">
        {{ p.StaffRecommendation === "Maybe" ? "X" : "" }}
      </div>
      <div class="col-1 text-center">
        {{ p.StaffRecommendation === "NotLikely" ? "X" : "" }}
      </div>
      <div class="col-1 text-center">
        {{ p.NyltRecommendation ? "X" : "" }}
      </div>
      <div class="col-3 text-left">
        {{ p.RecommendationComments }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportCloseoutRecommendationsParticipant',
  props: {
    participants: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>
